import React, { useEffect, useRef } from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import { BottomNextButton } from "components/common/BottomNextButton";
import { useMutation } from "@tanstack/react-query";
import { onboardingApi } from "api/onboardingApi";
import imgNiceLogo from "static/image/onboarding/approach_nice_logo.webp";
import imgApaLogo from "static/image/onboarding/approach_apa_logo.webp";

export default function Approach_7() {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate(`/onboarding_new/motivation/1`);
  };

  const pageKey = "approach_7";

  const { mutate: savePage } = useMutation(
    (pageId: string) => onboardingApi.savePage(pageId),
    {
      onSuccess: () => {},
    }
  );

  const savedRef = useRef(false);
  useEffect(() => {
    if (savedRef.current) return;
    savedRef.current = true;
    savePage(pageKey);
  }, []);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "70vh" }}>
      <Stack
        spacing={2}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <CustomTypography
          variant="Subtitle"
          fontWeight={700}
          sx={{
            color: theme.vars.palette.Content.Highlight,
          }}
        >
          {"의료 전문가가 가장 먼저 권합니다."}
        </CustomTypography>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {
            "영국 국립보건임상연구소(NICE)와 미국심리학회(APA)는 디스턴싱과 같은 가이드형 자기 도움 프로그램을 1차 치료법으로 권고합니다."
          }
        </CustomTypography>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {
            "이는 인지치료가 우울, 불안 등의 근본 원인을 다루는 효과적인 방법임이 증명되었기 때문입니다."
          }
        </CustomTypography>
        <Stack
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "4px",
            mt: "24px",
          }}
        >
          <img
            src={imgNiceLogo}
            alt="NICE"
            style={{
              width: "300px",
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
          <img
            src={imgApaLogo}
            alt="APA"
            style={{
              width: "292px",
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              mixBlendMode: "multiply",
            }}
          />
        </Stack>
      </Stack>
      <BottomNextButton
        disabled={false}
        onClick={handleNext}
        text={"다음"}
        highlightBackground={true}
      />
    </Box>
  );
}
